export default __webpack_public_path__ + "static/media/default.e97a6ec9e23562d71afe6e0b7022e4f4.png";